import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { useTranslation } from "react-i18next";
import { Icon } from "@mdi/react";
import { mdiLock } from "@mdi/js";

export function ViewerPrivacyDropdownMenuItem() {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem asChild>
      <a href={t("ViewerPrivacyDropdownMenuItem.href")} target="_blank">
        <Icon path={mdiLock} size="1.25rem" />
        {t("ViewerPrivacyDropdownMenuItem.label")}
      </a>
    </DropdownMenuItem>
  );
}
